import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Video } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useHub } from "@/components/AppShell";
import { Loader, PageHeader } from "@/components/common";
import { PINK } from "@/components/connect/parts";
import { Directory } from "@/components/calls/Directory";
import { Archive } from "@/components/calls/Archive";

export { CallLayer } from "@/components/calls/CallLayer";
export const SOON = "Video calls are coming soon";

export default function VideoCalls() {
  const { hub } = useHub();
  const [params] = useSearchParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState(params.get("archive") ? "archive" : "house");
  useEffect(() => { api.get(`/organizations/${hub.id}/connect/directory`).then(({ data }) => setD(data)).catch((e) => setErr(errMsg(e))); }, [hub.id]);
  if (err) return <p className="text-q-muted">{err}</p>;
  if (!d) return <Loader />;
  const tabBtn = (id, label) => <button role="tab" aria-selected={tab === id} onClick={() => setTab(id)} className={`min-h-[44px] rounded-full px-4 text-sm font-semibold ${tab === id ? "bg-q-raised text-q-text" : "text-q-muted"}`} data-testid={`calls-tab-${id}`}>{label}</button>;
  return (
    <div className="min-w-0" data-testid="video-calls-page">
      <PageHeader eyebrow="Connect" title="Video Calls" rgb={PINK} testid="video-calls-title" />
      <div className="mb-5 inline-flex rounded-full border border-q-line p-1" role="tablist">{tabBtn("house", "House")}{tabBtn("archive", "Archive")}</div>
      {tab === "archive" ? <Archive hub={hub} openId={params.get("archive")} /> : !d.enabled ? (
        <div className="q-card flex items-center gap-4" data-testid="video-calls-soon">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl" style={{ background: `rgba(${PINK},0.15)` }}><Video className="h-6 w-6" style={{ color: `rgb(${PINK})` }} /></span>
          <div><p className="font-display text-lg font-extrabold text-q-text">{SOON}</p><p className="text-sm text-q-muted">You can keep messaging the family in the meantime.</p></div>
        </div>
      ) : <Directory d={d} />}
    </div>
  );
}
